import ContentfulLink from './contentful/ContentfulLink'
import { ContentfulExperimentConfig } from './ContentfulExperimentConfig'

interface ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]
  openInNewTab?: boolean | null
}

class Link implements ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]
  openInNewTab?: boolean | null

  constructor({ id, navigationPath, scrollToHash, experimentConfig, openInNewTab }: ILink) {
    this.id = id
    this.navigationPath = navigationPath
    this.scrollToHash = scrollToHash
    this.experimentConfig = experimentConfig
    this.openInNewTab = openInNewTab
    return {
      ...this,
    }
  }

  static fromContentful(contentfulLink: ContentfulLink) {
    return new Link({
      id: contentfulLink.id,
      navigationPath: ContentfulLink.getLinkPath(contentfulLink),
      scrollToHash: contentfulLink.scrollToHash,
      experimentConfig: contentfulLink.experimentConfig,
      openInNewTab: contentfulLink.openInNewTab,
    })
  }
}

export default Link
